import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


 
import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { ModalAgregarRetenOrdenPago } from './modalAgregarRetenxOrdenPago';
import { ModalAgregarISLR } from './modalAgregarRetenISLR';
import moment from 'moment';


function TablaRetenISLR(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Codigo', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Descripción', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Base Imponible', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Alicuota', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Retención(%)', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sustraendo', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Total Retenido', textAlign: 'center' },
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha', textAlign: 'center' },


    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacionRete, setOperacionRete] = useState(0);
    const [records, setRecords] = useState([]);
    const [habiBot, setHabiBot] = useState(false);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtMonto = useRef([]);
    const txtMontoTotal = useRef();

    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const cerrarModal = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();
        setOperacionRete(ope);
        if (ope === 1) {
            if (parseFloat(props.totalbaseimpo) > 0) {
                setMostrar5(true);
            }
        } else if (ope === 2 && itemSelect >= 0) {
            setMostrar5(true);
        } else if (ope === 3 && itemSelect >= 0) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Está seguro de eliminar el registro?', icono: 'confirmacion' });
            //setMostrar5(true);
            //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        console.log(datos);

        let data = [...records];
        if (operacionRete === 1) {
            //for (let i = 0; i < datos.length; i++) {

            data.push({
                iddetalle: datos[0].iddetalle,
                idtiporetencion: datos[0].idtiporetencion,
                descripcion: datos[0].descripcion,
                baseimpo: datos[0].baseimpo,
                alicuota: datos[0].alicuota,
                retencion_por_ciento: datos[0].retencion_por_ciento,
                sustraendo: datos[0].sustraendo,
                totalrete: datos[0].totalrete,
                fecha: datos[0].fecha,
            });

            //}
        } else {
            data[itemSelect].iddetalle = datos[0].iddetalle;
            data[itemSelect].idtiporetencion = datos[0].idtiporetencion;
            data[itemSelect].descripcion = datos[0].descripcion;
            data[itemSelect].baseimpo = datos[0].baseimpo;
            data[itemSelect].alicuota = datos[0].alicuota;
            data[itemSelect].retencion_por_ciento = datos[0].retencion_por_ciento;
            data[itemSelect].sustraendo = datos[0].sustraendo;
            data[itemSelect].totalrete = datos[0].totalrete;
            data[itemSelect].fecha = datos[0].fecha;
        }
        setRecords(data);
        props.data(data);
    }

    useEffect(() => {
        
        blanquearCampos();
        if(props.operacion === 2 || props.operacion === 3){
            setHabiBot(true);
        } else if(props.operacion === 4){
            if (props.desde === 5){
                setHabiBot(false);
            } else {
                setHabiBot(true);
            }
        } else if(props.operacion === 1){
            setHabiBot(false);
        }
        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({
                    iddetalle: data[0].iddetalle,
                    numfactura: data[i].numfactura,
                    idtiporetencion: data[i].idtiporetencion,
                    descripcion: data[i].descripcion,
                    baseimpo: data[i].baseimpo,
                    alicuota: data[i].alicuota,
                    retencion_por_ciento: data[i].retencion_por_ciento,
                    sustraendo: data[i].sustraendo,
                    totalrete: data[i].totalrete,
                    fecha: data[i].fecha,
                });
            }
            setRecords(datos);
            props.data(datos);
        } else {
            setRecords([]);
        }

    }, [props.datarecords, props.desde]);

    const seleccionarFila = (index) => (e) => {
        if (props.operacion === 1 || (props.operacion === 4  && props.desde === 5)) {
            e.preventDefault();
            setItemSelect(index);
            props.data(records);
        }

    };

    const eliminarSolicitud = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idcompromiso !== datos[i].idcompromiso) {
                elementos.push(datos[i]);
            }

        }

        setRecords(elementos);
        props.data(elementos);
    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (operacionRete === 3) {
            let idret = records[itemSelect].idtiporetencion;
            let data = [...records.filter((it) => it.idtiporetencion !== idret)];
            setRecords(data);
            setItemSelect(0);
            props.data(records);
        } else {
            props.onHideEliminarRetIsrl();
            setMostrar5(true);
            //setOperacion(1);
            blanquearCampos()
        }
    };

    return (
        <div className='col-12 p-0 m-0'>
            <ModalAgregarISLR
                show={mostrar5}
                operacion={operacionRete}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                retenciones={records}
                itemselect={0}
                retencionsel={records[0]}
                natural={props.natural}
                montoislr={props.montoislr}
                retenido={props.retenido}
                totalbaseimpo={props.totalbaseimpo}
                totalfactura={props.totalfactura}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <div className="col-12 m-0 p-2 d-flex flex-wrap">
                <div className="col-11 p-0 m-0">
                    <TblContainer container={{ height: 150, width: '100%', overflow: 'auto'}}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idtiporetencion} className="table-bordered" style={{ padding: "0", height: '40px', cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "14px", textAlign: "center", width: "50px" }}>{item.idtiporetencion}</td>
                                        <td style={{ fontSize: "14px", textAlign: "left", width: "60px" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "14px", textAlign: "right", width: "60px" }}>{formatMoneda(item.baseimpo.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "14px", textAlign: "right", width: "60px" }}>{formatMoneda(item.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "14px", textAlign: "right", width: "60px" }}>{formatMoneda(item.retencion_por_ciento.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "14px", textAlign: "right", width: "60px" }}>{formatMoneda(item.sustraendo.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "14px", textAlign: "right", width: "60px" }}>{formatMoneda(item.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "14px", textAlign: "center", width: "60px" }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}
                </div>
                <div class="col-1 p-0 pl-2 m-0 d-flex flex-column justify-content-around">
                    <button onClick={opciones(1, '')} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-primary btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> INCLUIR</span><i className="pl-lg-1 fas fa-plus"></i> 
                    </button>
                    <button onClick={opciones(2, itemSelect)} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-warning btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> EDITAR</span><i className="pl-lg-1 fas fa-edit"></i> 
                    </button>
                    <button onClick={opciones(3, itemSelect)} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-danger btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> ELIMINAR</span><i className="pl-lg-1 fas fa-trash-alt"></i> 
                    </button>
                </div>
            </div>
        </div>
    );

}

export default TablaRetenISLR;
